import React from 'react';
import PropTypes from 'prop-types';

import {
    Button,
    ButtonGroup,
    FormHelp,
    Label,
    LabeledControl,
    Radio,
    Spacer,
    Textarea,
} from '@zillow/constellation';

import ErrorMessageConstants from 'app/shared/constants/ErrorMessageConstants';
import ReviewsConstants from 'app/shared/constants/ReviewsConstants';

const propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

const defaultProps = {
};

const { REPORT_REVIEW_REASONS } = ReviewsConstants;

class ReportReview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isSubmitting: false,
            errMessage: '',
            reason: REPORT_REVIEW_REASONS.INAPPROPRIATE,
            comment: '',
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCommentChange = this.handleCommentChange.bind(this);
        this.handleReasonChange = this.handleReasonChange.bind(this);
    }

    handleReasonChange(e, reason) {
        this.setState({ reason, errMessage: '' });
    }

    handleCommentChange(e) {
        this.setState({ comment: e.target.value, errMessage: '' });
    }

    handleSubmit() {
        this.setState({
            isSubmitting: true,
        });

        this.props.onSubmit(this.state.reason, this.state.comment)
            .catch(() => {
                this.setState({
                    isSubmitting: false,
                    errMessage: ErrorMessageConstants.DEFAULT_ERROR,
                });
            });
    }

    canSubmit() {
        const {
            reason, comment, isSubmitting, errMessage,
        } = this.state;
        return isSubmitting
            || errMessage !== ''
            || (reason === REPORT_REVIEW_REASONS.OTHER && comment === '');
    }

    render() {
        const {
            reason, comment, isSubmitting, errMessage,
        } = this.state;

        return (
            <Spacer paddingTop="md">
                <Label size="lg">Reason for reporting this review</Label>
                {Object.keys(REPORT_REVIEW_REASONS).map(key => (
                    <LabeledControl
                        key={key}
                        name="report-reason"
                        label={<Label>{ReviewsConstants.REPORT_REVIEW_REASONS_LABEL[key]}</Label>}
                        control={(
                            <Radio
                                checked={reason === REPORT_REVIEW_REASONS[key]}
                                onChange={e => this.handleReasonChange(e, REPORT_REVIEW_REASONS[key])}
                            />
                        )}
                    />
                ))}
                {reason === REPORT_REVIEW_REASONS.OTHER && (
                    <Spacer paddingTop="sm">
                        <Textarea
                            disabled={isSubmitting}
                            value={comment}
                            placeholder="Tell us why you're reporting this review"
                            onChange={this.handleCommentChange}
                        />
                    </Spacer>
                )}
                {errMessage &&
                    <FormHelp error={true}>{errMessage}</FormHelp>
                }
                <Spacer paddingTop="sm">
                    <ButtonGroup aria-label="report-controls">
                        <Button
                            buttonType="primary"
                            onClick={this.handleSubmit}
                            disabled={this.canSubmit()}
                        >
                            Report Review
                        </Button>
                        <Button
                            buttonType="secondary"
                            onClick={this.props.onCancel}
                            disabled={isSubmitting}
                        >
                            Cancel
                        </Button>
                    </ButtonGroup>
                </Spacer>
            </Spacer>
        );
    }
}

ReportReview.propTypes = propTypes;
ReportReview.defaultProps = defaultProps;

export default ReportReview;
